import cache from '@/utils/cache'
import { getUserInfo, logout } from '@/api/user'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    token: cache.getCache('token') || '',
    userInfo: cache.getCache('userInfo') || null,
    loginDialogVisible: false
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setLoginDialogVisible(state, visible) {
      state.loginDialogVisible = visible
    }
  },
  actions: {
    setToken(context, token) {
      context.commit('setToken', token)
    },
    setUserInfo(context, userInfo) {
      context.commit('setUserInfo', userInfo)
    },
    setLoginDialogVisible({ commit }, visible) {
      commit('setLoginDialogVisible', visible)
    },
    /**
     * 检查是否登录，未登录则弹窗提示
     * @param {Object} context
     * @returns {boolean} 是否已登录
     */
    checkLogin(context) {
      if (context.state.token) {
        return true
      }
      MessageBox.confirm('登录后才可发布信息，请先进行登录~', {
        confirmButtonText: '好的，去登录',
        cancelButtonText: '我再想想',
        showClose: false,
        center: true,
        customClass: 'login-confirm-box'
      }).then(() => {
        context.commit('setLoginDialogVisible', true)
      }).catch(() => {
        // 用户点击取消或关闭弹窗
      })
      
      return false
    },
    // 退出登录
    async logout(context) {
      await logout()
      context.commit('setToken', '')
      context.commit('setUserInfo', null)
      cache.removeCache('token')
      cache.removeCache('userInfo')
    },
    // 获取用户信息
    async getUserInfo(context) {
      const res = await getUserInfo()
      if (res.code !== 0) {
        Message.error(res.error)
        return
      }
      cache.setCache('userInfo', res.data)
      context.commit('setUserInfo', res.data)
    },
  },
  getters: {}
}
